<div  id="overlay" *ngIf="showing()">
</div>